<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="7">
            <a-form-model-item label="手机号码" prop="user">
              <a-input
                v-model="formInline.userPhone"
                placeholder="请输入手机号码"
              >
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="处理状态" prop="password">
              <a-select
                default-value="全部"
                style="width: 120px"
                @change="handleChange"
                v-model="formInline.isDeal"
              >
                <a-select-option value="全部"> 全部 </a-select-option>
                <a-select-option value="0"> 未处理 </a-select-option>
                <a-select-option value="1"> 已处理 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" html-type="submit"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <feedbackContent ref="aaa" :formInline="formInline"></feedbackContent>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>
</template>

<script>
import feedbackContent from "./feedbackContent.vue";
export default {
  components: {
    feedbackContent,
  },
  data() {
    return {
      formInline: {
        userPhone: "",
        isDeal: "",
      },
    };
  },
  methods: {
    handleSubmit(e) {
      console.log(this.formInline);
      this.$refs.aaa.query();
    },
    resetForm() {
      this.$refs.aaa.getUserList();
      this.formInline.userPhone = "";
    },
    handleChange(e) {
      console.log(e);
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/systemManagement/feedback/feedbackHome.vue